import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import menuJson from './menuJson';
import socialNetworksJson from './contactJson.js';
import './menu.css';

let iconWhatsapp = `${process.env.PUBLIC_URL}/images/social/whatsapp.svg`;
let iconMail = `${process.env.PUBLIC_URL}/images/social/mail.svg`;

function Menu() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [visibleItems, setVisibleItems] = useState([]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);

        if (!menuOpen) {
            setVisibleItems([]);

            setTimeout(() => {
                menuJson.forEach((_, index) => {
                    setTimeout(() => {
                        setVisibleItems(prev => [...prev, index]);
                    }, index * 150);
                });
            }, 300);
        } else {
            setVisibleItems([]);
        }
    };

    useEffect(() => {
        if (menuOpen) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }

        return () => {
            document.body.classList.remove('no-scroll');
        };
    }, [menuOpen]);

    return (
        <div className='fullMenu'>
            <div className={`menu-background ${menuOpen ? 'visible' : ''}`} onClick={toggleMenu}></div>
            <div className='menuCircle'>
                <div className={`menu-hamburguesa ${menuOpen ? 'change' : ''}`} onClick={toggleMenu}>
                    <div className="bar1"></div>
                    <div className="bar2"></div>
                    <div className="bar3"></div>
                </div>
            </div>
            <nav className={menuOpen ? 'show' : ''}>
                <ul className='menuIndex'>
                    {menuJson.map((menues, index) => (
                        <li key={menues.idSearch} className={visibleItems.includes(index) ? 'visible' : ''}>
                            <Link to={menues.idSearch} onClick={toggleMenu}>
                                {menues.titulo}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>

            <div className={`dataContactMenu ${menuOpen ? 'visible' : ''}`}>
                <div className='linksMenu'>
                    <a href='https://api.whatsapp.com/send?phone=541141887434&text=hello%20world'>
                        <img width="100%" src={iconWhatsapp} alt='whatsapp' loading="lazy"></img>
                    </a>
                    <a href='mailto:info@estudioindex.com.ar'>
                        <img width="100%" src={iconMail} alt='mail' loading="lazy"></img>
                    </a>
                </div>
                <h3>Maure 2945<span>Colegiales . 1426</span></h3>
                <h4>BUENOS AIRES - ARGENTINA</h4>
                <ul className='redes flexIndex'>
                    {socialNetworksJson.map((social) => {
                        let img = `${process.env.PUBLIC_URL}/images/social/${social.alt}.svg`;
                        return (
                            <li key={social.titulo}>
                                <a href={social.link} target="_blank" rel="noopener noreferrer">
                                    <i>
                                        <img width="100%" src={img} alt={social.titulo} loading="lazy"></img>
                                    </i>
                                </a>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    );
}

export default Menu;